import MasonryGalleryContainer from "../../../components/miscellaneous/gallery/masonryGallery";

const MasonryGallery = () => {
  return <MasonryGalleryContainer />;
};

export default MasonryGallery;
